/** @format */

import React from "react";

const NotFound = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #e0eafc 0%, #cfdef3 100%)",
        fontFamily: "Segoe UI, Arial, sans-serif",
      }}>
      <h1
        style={{
          fontSize: "6rem",
          margin: 0,
          color: "#2d3a4b",
          letterSpacing: "8px",
          textShadow: "2px 2px 8px #b0c4de",
        }}>
        404
      </h1>

      <h2
        style={{
          color: "#4b6584",
          margin: "16px 0 8px 0",
        }}>
        Uzr! Sahifa topilmadi
      </h2>

      <p
        style={{
          color: "#6c7a89",
          fontSize: "1.2rem",
          marginBottom: "32px",
        }}>
        Siz izlayotgan sahifa olib tashlangan,
        <br /> nomi o'zgartirilgan yoki vaqtincha mavjud emas.
      </p>

      <a
        href='/'
        style={{
          padding: "12px 32px",
          background: "#3867d6",
          color: "#fff",
          borderRadius: "24px",
          textDecoration: "none",
          fontWeight: "bold",
          boxShadow: "0 4px 12px rgba(56,103,214,0.15)",
          transition: "background 0.2s",
        }}
        onMouseOver={(e) => (e.target.style.background = "#274b8e")}
        onMouseOut={(e) => (e.target.style.background = "#3867d6")}>
        Ortga qaytish
      </a>

      <div
        style={{
          marginTop: "48px",
          fontSize: "4rem",
          opacity: 0.15,
          userSelect: "none",
        }}>
        🚰💧
      </div>
    </div>
  );
};

export default NotFound;
